<template>
  <div class="blockchain-value">
    <div
      class="blockchain-cell"
      :class="{'cell-change': animate}"
      :style="{transform}"
      v-for="(item, index) in blockchain"
      :key="index + 'new'"
    >
      <div class="inline-cell">{{formatTime(item.UpStartTime)}}</div>
      <div class="inline-cell max-2">{{item.UpDataCount}}</div>
      <div class="inline-cell">{{item.BlockchainId.slice(0, 20)}}</div>
    </div>

    <div
      class="blockchain-cell"
      :class="{'cell-change': animate}"
      :style="{transform}"
      v-for="(item, index) in oldBlockchain"
      :key="index + 'old'"
    >
      <div class="inline-cell">{{formatTime(item.UpStartTime)}}</div>
      <div class="inline-cell max-2">{{item.UpDataCount}}</div>
      <div class="inline-cell">{{item.BlockchainId.slice(0, 20)}}</div>
    </div>
  </div>
</template>

<script>
const f = (v) => v >= 10 ? v : `0${v}`
export default {
  props: {
    blockchain: Array,
    oldBlockchain: Array
  },
  data () {
    return {
      transform: '',
      animate: false
    }
  },
  methods: {
    formatDate (time) {
      const date = new Date(time)
      const [y, m, d] = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      return `${y}年${f(m)}月${f(d)}日`
    },
    formatTime (time) {
      const date = new Date(time)
      const [h, m, s] = [date.getHours(), date.getMinutes(), date.getSeconds()]
      return `${f(h)}时${f(m)}分${f(s)}秒`
    }
  },
  watch: {
    oldBlockchain (value) {
      if (value.length) {
        this.transform = `translateY(-${value.length}00%)`
        setTimeout(() => {
          this.animate = true
          this.transform = `translateY(0)`
          setTimeout(() => {
            this.animate = false
          }, 2000)
        }, 200)
      }
    }
  }
}
</script>

<style scoped lang="less">
.blockchain-value {
  height: 35vh;
  overflow: hidden;
  color: #fff;
  padding-left: 5%;
  padding-right: 5%;
  box-sizing: border-box;
  text-align: left;
  .cell-change {
    transition: all 2s;
    transform: translateY(0);
  }
  .blockchain-cell {
    height: 8.333%;
    display: flex;
    align-items: center;
    ::before {
      content: '';
      display: inline-block;
      width: .6vw;
      height: .6vw;
      border-radius: .3vw;
      margin-right: .2vw;
    }
    :nth-of-type(1)::before {
      background-color: #d50348;
    }
    :nth-of-type(2)::before {
      background-color: #0879f3;
    }
    :nth-of-type(3)::before {
      background-color: #0cff01;
    }
    .inline-cell {
      display: inline-block;
      font-weight: bold;
      &:nth-of-type(1) {
        margin-right: 1.5em;
      }
    }
    .max-2 {
      width: 3em;
    }
  }
}
</style>
